// noinspection ES6UnusedImports
import React, {useEffect} from 'react';
import MessageBroker from '@bonprix/pattern-library/components/message-broker.js';
import Messages from '@core/scripts/components/messages';

export default function PlattformAttributes({config}) {
    useEffect(() => {
        let payload = {pageType: config.pageType, pageViewId: config.pageViewId};

        if (config.pageType === 'canal') {
            MessageBroker.publish(Messages.CHANNEL.OPENED, payload);
        } else if (config.pageType === 'wishlist') {
            MessageBroker.publish(Messages.WISHLIST.OPENED, payload);
        } else if (config.pageType === 'adp') {
            MessageBroker.publish(Messages.ADP.OPENED, payload);
        } else if (config.pageType === 'aop') {
            MessageBroker.publish(Messages.ARTICLE_OVERVIEW.OPENED, payload);
        } else if (config.pageType === 'basket') {
            MessageBroker.publish(Messages.CART.OPENED, payload);
        } else if (config.pageType === 'checkout') {
            MessageBroker.publish(Messages.CHECKOUT.OPENED, payload);
        }
    }, []);
}
